import type { FC } from 'react';

import cn from 'classnames';
import sanitizeHtml from 'sanitize-html';

import type { RichTextProps } from './RichText.entity';

import styles from './RichText.module.css';

export const RichText: FC<RichTextProps> = ({ noPadding, richText, className }) => {
  if (!richText) return null;
  const classNames = cn(styles.richText, noPadding && styles.noPadding, className);

  return (
    <div
      className={classNames}
      data-rich-text-component
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(richText) }}
    ></div>
  );
};
